module.exports = __webpack_public_path__ + "img/13.719a724d.jpg";